/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  homes.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/7/4 14:44
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
 import { axiosAPIUrl, Parameter } from "./indexORC";

 /**
 *  获取预授信额度
 * @param params
 */
 export function getPreCredit(Parameter: Parameter = {}) {
   return axiosAPIUrl<Ajax.Response<any>>({
     url: '/cykjAuthentication/PreCredit/getPreCredit',
     method: 'get',
     params: Parameter
   })
 }
 /**
 *  获取预授信URL
 * @param params
 */
   export function getPreCreditUrl(Parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
      url: '/cykjAuthentication/PreCredit/getPreCreditUrl',
      method: 'post',
      data: Parameter
    })
  }